export default function WorkflowCaseStudies() {
  const cases = [
    {
      company: '某大型医疗集团',
      industry: '医疗保健',
      challenge: '多院区电子病历系统分散，医生查阅患者历史记录困难，影响诊疗效率',
      solution: '实施统一的文档工作流系统，整合所有院区的电子病历，建立智能检索和权限管理机制',
      results: [
        '病历查询时间减少80%',
        '医生工作效率提升45%',
        '患者满意度提高35%',
        '医疗差错率降低60%'
      ],
      icon: 'ri-hospital-line',
      color: 'teal'
    },
    {
      company: '某国际律师事务所',
      industry: '法律服务',
      challenge: '案件文档管理混乱，合同审核流程冗长，多个版本难以追踪',
      solution: '部署智能文档管理系统，建立标准化的审核流程，实现版本控制和协作编辑',
      results: [
        '合同审核周期缩短50%',
        '文档检索效率提升70%',
        '版本管理准确率99.9%',
        '客户响应速度提高60%'
      ],
      icon: 'ri-briefcase-line',
      color: 'blue'
    },
    {
      company: '某制造业龙头企业',
      industry: '制造业',
      challenge: '设计图纸和技术文档分散在各部门，协作困难，版本混乱导致生产错误',
      solution: '建立集中化的技术文档管理平台，实现跨部门协作和实时同步',
      results: [
        '设计变更响应时间减少65%',
        '生产错误率降低75%',
        '研发协作效率提升55%',
        '文档管理成本节省40%'
      ],
      icon: 'ri-tools-line',
      color: 'purple'
    }
  ];

  const colorClasses: Record<string, { bg: string; text: string; border: string }> = {
    teal: { bg: 'bg-teal-50', text: 'text-teal-600', border: 'border-teal-200' },
    blue: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-200' },
    purple: { bg: 'bg-purple-50', text: 'text-purple-600', border: 'border-purple-200' }
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            成功案例
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            看看我们如何帮助各行业客户实现文档工作流程的数字化转型
          </p>
        </div>

        <div className="space-y-8">
          {cases.map((caseStudy, index) => {
            const colors = colorClasses[caseStudy.color];
            return (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="grid lg:grid-cols-3 gap-8 p-8 lg:p-12">
                  <div className="lg:col-span-1">
                    <div className={`w-16 h-16 ${colors.bg} rounded-2xl flex items-center justify-center mb-6`}>
                      <i className={`${caseStudy.icon} text-3xl ${colors.text}`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {caseStudy.company}
                    </h3>
                    <div className={`inline-block px-3 py-1 ${colors.bg} ${colors.text} rounded-full text-sm font-medium mb-6`}>
                      {caseStudy.industry}
                    </div>
                    
                    <div className="space-y-4">
                      <div>
                        <h4 className="font-bold text-gray-900 mb-2">挑战</h4>
                        <p className="text-gray-600 text-sm leading-relaxed">
                          {caseStudy.challenge}
                        </p>
                      </div>
                      
                      <div>
                        <h4 className="font-bold text-gray-900 mb-2">解决方案</h4>
                        <p className="text-gray-600 text-sm leading-relaxed">
                          {caseStudy.solution}
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="lg:col-span-2">
                    <h4 className="text-xl font-bold text-gray-900 mb-6">实施成果</h4>
                    <div className="grid sm:grid-cols-2 gap-6">
                      {caseStudy.results.map((result, idx) => (
                        <div 
                          key={idx}
                          className={`bg-white p-6 rounded-xl border ${colors.border} hover:shadow-lg transition-all duration-300`}
                        >
                          <div className="flex items-start gap-3">
                            <i className={`ri-checkbox-circle-fill ${colors.text} text-xl flex-shrink-0 mt-0.5`}></i>
                            <span className="text-gray-700 font-medium">{result}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    <div className="mt-8">
                      <a 
                        href="/contact"
                        className={`inline-flex items-center ${colors.text} font-medium hover:underline cursor-pointer whitespace-nowrap`}
                      >
                        <span>查看完整案例</span>
                        <i className="ri-arrow-right-line ml-2"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
